import { createAsyncThunk } from "@reduxjs/toolkit";

import { getSarvahDetails } from "../../../services";

export const sendOtpThunk = createAsyncThunk(
  "/sendOtp",
  async (sarvahRequest, { rejectWithValue }) => {
    try {
      const result = await getSarvahDetails(`/send-otp`, {
        ...sarvahRequest,
      });
      return result.data;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data?.error });
    }
  }
);

export const verifyOtpThunk = createAsyncThunk(
  "/verifyOtp",
  async (sarvahRequest, { rejectWithValue }) => {
    try {
      const result = await getSarvahDetails(`/verify-otp`, {
        ...sarvahRequest,
      });
      return result.data;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data?.error });
    }
  }
);

export const submitFormThunk = createAsyncThunk(
  "/submitSarvahForm",
  async (sarvahRequest, { rejectWithValue }) => {
    try {
      const result = await getSarvahDetails(`/submit-sarvah-form`, {
        ...sarvahRequest,
      });
      return result.data;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data?.error });
    }
  }
);
